import { CriteriaEngineByIdResponse, CriteriaEnginePT, CriteriaEngineResponse } from "@/models/consignado/criteriaEngine.model"
import { axiosConsignadoInstance } from "../axiosInstance"


export const createCriteriaEngine = async (body: CriteriaEnginePT) => {
  try {
    const newCriteriaEngine = await axiosConsignadoInstance.post('/api-consignado-trabalhador/v1/motor-credito', body)
    return newCriteriaEngine.data
  } catch (error) {
    console.error('Erro at creating new criteria engine', error)
    throw error
  }
}

export const updateCriteriaEngine = async (body: CriteriaEnginePT) => {
  try {
    const newCriteriaEngine = await axiosConsignadoInstance.patch(`/api-consignado-trabalhador/v1/motor-credito/${body.id}`, body)
    return newCriteriaEngine.data
  } catch (error) {
    console.error('Erro at updating criteria engine', error)
    throw error
  }
}

export const getCriteriaEngines = async (pagina: number = 1, tamanhoPagina: number = 10, ordenarPor: string = 'id', direcaoOrdenacao: string = 'ASC'): Promise<CriteriaEngineResponse> => {
  try {
    const criteriaEngines = await axiosConsignadoInstance.get('/api-consignado-trabalhador/v1/motor-credito', {
      params: {
        pagina,
        tamanhoPagina,
        ordenarPor,
        direcaoOrdenacao
      }
    })
    return criteriaEngines.data
  } catch (error) {
    console.error('Erro at getting criteria engines', error)
    throw error
  }
}

export const getCriteriaEngineById = async(id: number): Promise<CriteriaEngineByIdResponse> => {
  try {
    const request = await axiosConsignadoInstance.get(`/api-consignado-trabalhador/v1/motor-credito/${id}`)
    return request.data
  } catch (error) {
    console.error('Erro at getting criteria engine by id', error)
    throw error
  }
}

export const deleteCriteriaRule = async(id: string): Promise<any> => {
  try {
    const request = await axiosConsignadoInstance.delete(`/api-consignado-trabalhador/v1/motor-credito/criterios/${id}`)
    return request.data
  } catch (error) {
    console.error('Error at deleting criteria rule', error)
  }
}

export const deleteCriteriaSet = async(id: string): Promise<any> => {
  try {
    const request = await axiosConsignadoInstance.delete(`/api-consignado-trabalhador/v1/motor-credito/conjuntos-criterios/${id}`)
    return request.data
  } catch (error) {
    console.error('Error at deleting criteria sets', error)
  }
}

export const deleteCriteriaEngine = async(id: number): Promise<any> => {
  try {
    const request = await axiosConsignadoInstance.delete(`/api-consignado-trabalhador/v1/motor-credito/${id}`)
    return request.data
  } catch (error) {
    console.error('Error at deleting criteria sets', error)
  }
}
